import { render, staticRenderFns } from "./SortDialog.vue?vue&type=template&id=46a5c817&scoped=true"
import script from "./SortDialog.vue?vue&type=script&lang=js"
export * from "./SortDialog.vue?vue&type=script&lang=js"
import style0 from "./SortDialog.vue?vue&type=style&index=0&id=46a5c817&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5c817",
  null
  
)

export default component.exports